import { forwardRef, type Ref, type SVGProps } from "react";
const IconBeautySpaFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M11 6h2a1 1 0 0 0 0-2H9a1 1 0 0 0 0 2v2a1 1 0 0 0-1 1v1q0 .044.004.086a2 2 0 0 0-1.417 1.83l-.543 13.042A1 1 0 0 0 7.043 26h5.915a1 1 0 0 0 1-1.042l-.544-13.041a2 2 0 0 0-1.417-1.831q.004-.042.004-.086V9a1 1 0 0 0-1-1zm9 0a1 1 0 0 0-1 1v2.126c-1.725.444-3 2.01-3 3.874v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V13a4 4 0 0 0-3-3.874V7a1 1 0 0 0-1-1z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconBeautySpaFilledSVG);
ForwardRef.displayName = "IconBeautySpaFilled";
export { ForwardRef as IconBeautySpaFilled };
